namespace $.$$ {
	export class $shm_hitalama_tasks extends $.$shm_hitalama_tasks {

	}
}
